import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PaisDto } from '../../../../dto/expediente/pais.dto';
import { TipoDocumentoDto } from '../../../../dto/expediente/tipo-documento.dto';
import { FormField } from '../../../../dto/util/form-field';
import { FormGroup, Validators } from '@angular/forms';
import { Constants } from '../../../../constants/constants';
import { ArchivoItemDto } from '../../../util/archivos-tramite/dto/ArchivoItemDto';
import { PersonaLoginDTO } from '../../../../dto/util/persona.dto';
import { TranslateService } from '@ngx-translate/core';
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';
import { ListasService } from '../../../../services/listas.service';
import { TextTransformService } from '../../../util/text-transform/text-transform.service';
import { combineLatest } from 'rxjs';
import { ListaValorResponseDto } from '../../../../dto/tramites/lista_valor.dto';
import { Router } from '@angular/router';
import { TramiteValidacionJudicialDto } from '../../../../dto/tramites/tramite-validacion-judicial.dto';
import { TramiteSupersociedadesValidacionJudicialService } from '../../../../services/tramite-supersociedades-validacion-judicial.service';
import { TramiteService } from '../../../../services/tramite.service';

@Component({
  selector: 'app-validacion-judicial-sucursales',
  templateUrl: './validacion-judicial-sucursales.component.html',
  styleUrl: './validacion-judicial-sucursales.component.scss'
})
export class ValidacionJudicialSucursalesComponent implements OnInit, OnChanges {
  @Input() tramiteVji?: TramiteValidacionJudicialDto;
  @Input() idTipoSolicitante?: string = '';
  @Input() paises: PaisDto[] = [];
  @Input() listaTiposDocumento: TipoDocumentoDto[] = [];

  // Formularios
  vjiSucursalIdentificacionDeudor: FormField[] = [];
  vjiSucursalInformacionProfesionales: FormField[] = [];
  vjiSucursalSupuestosAdmisibilidad: FormField[] = [];
  vjiSucursalRelacionPasivos: FormField[] = [];
  vjiSucursalInformacionFinancieraMes: FormField[] = [];
  vjiSucursalInformacionFinancieraAnio: FormField[] = [];
  vjiSucursalEstadosFinancieros: FormField[] = [];
  vjiSucursalOtrosDocumentos: FormField[] = [];
  vjiSucursalReporteBienesMobiliarios: FormField[] = [];
  vjiSucursalDocumentosAdicionales: FormField[] = [];

  formIdentificacionDeudor!: FormGroup;
  formInformacionProfesionales!: FormGroup;
  formSupuestosAdmisibilidad!: FormGroup;
  formRelacionPasivos!: FormGroup;
  formInformacionFinancieraMes!: FormGroup;
  formInformacionFinancieraAnio!: FormGroup;
  formEstadosFinancieros!: FormGroup;
  formOtrosDocumentos!: FormGroup;
  formReporteBienesMobiliarios!: FormGroup;
  formDocumentosAdicionales!: FormGroup;

  // Tramite
  tipoTramite: number = Constants.ID_ENTIDAD_SSO_VJI;
  idTramite!: number | null;
  entidadId = Constants.ID_ENTIDAD_SUPER_SOCIEDADES;
  idTramiteSsoVji!: number;

  // Archivos
  mostrarArchivos: boolean = true;
  enviarDocumentos = false;
  archivosCargados: ArchivoItemDto[] = [];

  enviarEntidad: boolean = false;

  // Multilenguaje
  vjiText: any = {};
  comunText: any = {};
  alertaText: any = {};

  dataUsuario!: PersonaLoginDTO;

  auxIdCountry: number[] = [];
  grupoPreparadores: { Id: number, Nombre: string }[] = [];

  currentYear: number = 0;
  lastYear: number = 0;
  yearBeforeLast: number = 0;
  twoYearsAgo: number = 0;

  listaSolicitante: ListaValorResponseDto[] =[];
  // Boolean
  entidad = '';
  constructor(
    private readonly translate: TranslateService,
    private readonly alertaModalService: AlertaModalService,
    private readonly router: Router,
    private readonly listaServices: ListasService,
    private readonly textTransformService: TextTransformService,
    private readonly serviceValidacionJ: TramiteSupersociedadesValidacionJudicialService,
    private readonly tramiteService: TramiteService,
  ) {

  }

  ngOnInit(): void {
    this.dataUsuario = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });
    combineLatest([
      this.translate.stream('tramites'),
      this.translate.stream('comun-label'),
    ]).subscribe(([tramitesText, comunLabelText]) => {
      // Procesar el texto de 'tramites'
      for (const key of Object.keys(tramitesText)) {
        this.vjiText[key] = tramitesText[key];
      }

      this.tramiteService.obtenerNombreEntidadPorId(1).subscribe({
        next: (data) => {
          this.entidad = data.entidad;
        },
        error: (err) => console.error('Error al obtener entidad', err),
      });

      // Procesar el texto de 'comun-label'
      for (const key of Object.keys(comunLabelText)) {
        this.comunText[key] = comunLabelText[key];
      }
      this.currentYear = new Date().getFullYear();
      this.lastYear = this.currentYear - 1;
      this.yearBeforeLast = this.currentYear - 2;
      this.twoYearsAgo = this.currentYear - 3;
      this.initSucursal();
    });
    this.getListas();
  }

  ngOnChanges(changes: SimpleChanges) {
    const tramite: TramiteValidacionJudicialDto =
      changes['tramiteVji'].currentValue;

    //Si el tramite cambia, se seta toda la informacion del mismo
    if (tramite !== undefined) {
      this.idTramite = tramite.id!;
      setTimeout(() => {
        this.vjiSucursalIdentificacionDeudor = this.vjiSucursalIdentificacionDeudor.map(field => {
          switch (field.name) {
            case 'tipoDeDocumento':
              field.value = tramite.tipoIdentificacion.id;
              break;
            case 'numberOfDocument':
              field.value = tramite.numeroIdentificacion;
              break;
            case 'nombre':
              field.value = tramite.nombreRazonSocial;
              break;
            case 'codigoCIIU':
              field.value = tramite.codigoCIIU?.id?.toString();
              break;
            case 'macrosector':
              field.value = tramite.macrosector?.id;
              break;
            case 'country':
              field.value = tramite.paisDomicilio.id;
              break;
            case 'departament':
              field.value = tramite.departamentoDomicilio.id;
              break;
            case 'municipality':
              field.value = tramite.municipioDomicilio.id;
              break;
            case 'otroDepartamento':
              field.value = tramite.departamentoExtranjero ?? '';
              break;
            case 'otroMunicipio':
              field.value = tramite.ciudadExtranjero ?? '';
              break;
            case 'addressNotificacion':
              field.value = tramite.direccionNotificacion;
              break;
            case 'email':
              field.value = tramite.correoElectronicoNotificacion;
              break;
            case 'telefono':
              field.value = tramite.telefono;
              break;
            case 'numeroEmpleadasMujeres':
              field.value = tramite.numeroEmpleadosMujeres;
              break;
            case 'numeroEmpleadosHombres':
              field.value = tramite.numeroEmpleadosHombres;
              break;
            case 'representanteLegal':
              field.value = tramite.representanteLegal?.id;
              break;
          }
          return field;
        })
      }, 500);
      setTimeout(() => {
        this.vjiSucursalInformacionProfesionales = this.vjiSucursalInformacionProfesionales.map(field => {
          switch (field.name) {
            case 'contador':
              field.value = tramite.contador.id;
              break;
            case 'revisorFiscal':
              field.value = tramite.revisorFiscal?.id;
              break;
            case 'apoderado':
              field.value = tramite.idApoderado! ?? undefined;
              break;
          }
          return field;
        })
        this.vjiSucursalSupuestosAdmisibilidad = this.vjiSucursalSupuestosAdmisibilidad.map(field => {
          switch (field.name) {
            case 'certificoActividad':
              field.value = tramite.certificoActividad?.id;
              break;
          }
          return field;
        })
        this.vjiSucursalRelacionPasivos = this.vjiSucursalRelacionPasivos.map(field => {
          switch (field.name) {
            case 'tienePasivosRetenciones':
              field.value = tramite.tienePasivosRetenciones != undefined ? this.getValorRadioButton(tramite.tienePasivosRetenciones) : undefined;
              break;
            case 'tienePasivosDescuentos':
              field.value = tramite.tienePasivosDescuentos != undefined ? this.getValorRadioButton(tramite.tienePasivosDescuentos) : undefined;
              break;
            case 'tienePasivosAportes':
              field.value = tramite.tienePasivosAportes != undefined ? this.getValorRadioButton(tramite.tienePasivosAportes) : undefined;
              break;
          }
          return field;
        })
        this.vjiSucursalInformacionFinancieraMes = this.vjiSucursalInformacionFinancieraMes.map(field => {
          switch (field.name) {
            case 'fechaEstadoFinancieroMesAnterior':
              field.value = tramite.fechaEstadoFinancieroMesAnterior;
              break;
            case 'valorTotalActivosMesAnterior':
              field.value = tramite.valorTotalActivosMesAnterior;
              break;
            case 'valorTotalPasivosMesAnterior':
              field.value = tramite.valorTotalPasivosMesAnterior;
              break;
            case 'valorTotalPatrimonioMesAnterior':
              field.value = tramite.valorTotalPatrimonioMesAnterior;
              break;
            case 'codigoGrupoPreparadores':
              field.value = this.getIdGrupoPreparadores(tramite.codigoGrupoPreparadores);
              break;
          }
          return field;
        })
        this.vjiSucursalInformacionFinancieraAnio = this.vjiSucursalInformacionFinancieraAnio.map(field => {
          switch (field.name) {
            case 'fechaEstadoFinancieroAnioAnterior':
              field.value = tramite.fechaEstadoFinancieroAnioAnterior;
              break;
            case 'valorTotalActivosAnioAnterior':
              field.value = tramite.valorTotalActivosAnioAnterior;
              break;
            case 'valorTotalPasivosAnioAnterior':
              field.value = tramite.valorTotalPasivosAnioAnterior;
              break;
            case 'valorTotalIngresosOrdinariosAnioAnterior':
              field.value = tramite.valorTotalIngresosOrdinariosAnioAnterior;
              break;
            case 'valorTotalOtrosIngresosAnioAnterior':
              field.value = tramite.valorTotalOtrosIngresosAnioAnterior;
              break;
            case 'tieneIversionesSubsidiarias':
              field.value = tramite.tieneInversiones != undefined ? this.getValorRadioButton(tramite.tieneInversiones) : undefined;
              break;
            case 'valorTotalGananciaMetodoParticipacion':
              field.value = tramite.valorTotalGananciaMetodoParticipacion;
              break;
            case 'valorTotalGananciaMetodoAlCosto':
              field.value = tramite.valorTotalGananciaMetodoAlCosto;
              break;
            case 'valorTotalGananciaMetodoValorRazonable':
              field.value = tramite.valorTotalGananciaMetodoValorRazonable;
              break;
          }
          return field;
        })
        this.vjiSucursalEstadosFinancieros = this.vjiSucursalEstadosFinancieros.map(field => {
          switch (field.name) {
            case 'informacionRemitida':
              field.value = tramite.tieneInformacionRemitida != undefined ? this.getValorRadioButton(tramite.tieneInformacionRemitida) : undefined;
              break;
            case 'radicado2023':
              field.value = tramite.radicado2023;
              break;
          }
          return field;
        })
        this.vjiSucursalOtrosDocumentos = this.vjiSucursalOtrosDocumentos.map(field => {
          switch (field.name) {
            case 'causalDisolucion':
              field.value = tramite.tieneCausalDisolucion != undefined ? this.getValorRadioButton(tramite.tieneCausalDisolucion) : undefined;
              break;
            case 'pasivosPensionales':
              field.value = tramite.tienePasivosPensionales != undefined ? this.getValorRadioButton(tramite.tienePasivosPensionales) : undefined;
              break;
            case 'garanteTerceros':
              field.value = tramite.esGaranteTerceros != undefined ? this.getValorRadioButton(tramite.esGaranteTerceros) : undefined;
              break;
          }
          return field;
        })
        this.vjiSucursalReporteBienesMobiliarios = this.vjiSucursalReporteBienesMobiliarios.map(field => {
          switch (field.name) {
            case 'garantiaInmobiliaria':
              field.value = tramite.tieneBienesGarantiaInmobiliaria != undefined ? this.getValorRadioButton(tramite.tieneBienesGarantiaInmobiliaria) : undefined;
              break;
          }
          return field;
        })
        this.vjiSucursalDocumentosAdicionales = this.vjiSucursalDocumentosAdicionales.map(field => {
          switch (field.name) {
            case 'descripcion':
              field.value = tramite.descripcion;
              break;
          }
          return field;
        })
      }, 800);

    } else {
      this.getData();
    }
  }

  getValorRadioButton(valor: boolean) {
    if (valor) {
      return 1;
    } else {
      return 2;
    }
  }

  getListas() {
    // Tipo solicitante
    this.listaServices
      .listaValor(Constants.ROI_TIPO_SOLICITANTE)
      .subscribe(response => {
        this.listaSolicitante = response as ListaValorResponseDto[];
      });
    // Macrosector
    this.listaServices
      .listaValor(Constants.MACROSECTOR)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.vjiSucursalIdentificacionDeudor = this.vjiSucursalIdentificacionDeudor.map(field => {
          if (field.name === 'macrosector') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
          }
          // Setear tipos Documento
          if (field.name === 'tipoDeDocumento') {
            field.options = this.listaTiposDocumento.map(item => ({
              Id: item.Id!,
              Nombre: item.Nombre!,
            }));
          }
          return field;
        });
      });
    // CESE_PAGOS
    this.listaServices
      .listaValor(Constants.CESE_PAGOS)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.vjiSucursalSupuestosAdmisibilidad = this.vjiSucursalSupuestosAdmisibilidad.map(field => {
          if (field.name === 'certificoActividad') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
          }
          return field;
        });
      });
    // PREPARADOR_INFORMACION
    this.listaServices
      .listaValor(Constants.PREPARADOR_INFORMACION)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.vjiSucursalInformacionFinancieraMes = this.vjiSucursalInformacionFinancieraMes.map(field => {
          if (field.name === 'codigoGrupoPreparadores') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
            this.grupoPreparadores = data.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
          }
          return field;
        });
      });
  }

  initSucursal() {
    this.vjiSucursalIdentificacionDeudor = [
      // SECCION INICIAL
      {
        name: 'tipoSolicitud',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_solicitud'],
        type: 'text',
        required: false,
        visible: true,
        width: '6',
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
        },
        disabled: true,
        value: 'Validación Judicial'
      },
      {
        name: 'normaAplicable',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['norma_aplicable'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
        },
        disabled: true,
        value: 'Ley 1116 de 2006'
      },
      // SECCION Identificación del deudor (Artículo 2, Ley 1116 de 2006)
      {
        isSubtitle: true,
        subtitleText:
          this.vjiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][1],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'tipoDeDocumento',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        disabled: true,
        errorMessages: { required: this.comunText['tipo-documento-required'] },
        // personTypeId: '1'
      },
      {
        name: 'numberOfDocument',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_documento'],
        placeholder: '',
        type: 'text',
        required: true,
        disabled: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-documento-required'],
        },
      },
      {
        name: 'nombre',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['nombre'],
        placeholder: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['nombre'],
        type: 'text',
        required: true,
        disabled: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'codigoCIIU',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['ciiu'],
        type: 'select',
        required: true,
        options: [
          { Id: '6201', Nombre: 'Actividades de desarrollo de sistemas informáticos' },
          { Id: '4711', Nombre: 'Comercio al por menor en tiendas de alimentos' },
          { Id: '1071', Nombre: 'Fabricación de productos de panadería' },
          { Id: '4931', Nombre: 'Transporte de pasajeros por carretera' },
          { Id: '8610', Nombre: 'Actividades de hospitales' }
        ],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'macrosector',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['macrosector'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        isSubtitle: true,
        subtitleText:
          this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['domicilio'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        validation: [Validators.maxLength(25)],
        errorMessages: {
          required: this.comunText['country-required'],
        },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        placeholder: 'Ingresa el Departamento',
        width: '6',
        visible: true,
        validation: [Validators.maxLength(50)],
        errorMessages: {
          required: this.comunText['departament-required'],
        },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        placeholder: this.comunText['municipality'],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.comunText['municipality-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [Validators.maxLength(30)],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['campo-maxlength'],
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip:
          this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['escriba-departamento'],
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [Validators.maxLength(30)],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
          maxlength: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['campo-maxlength'],
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['escriba-municipio'],
      },
      {
        name: 'addressNotificacion',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        isSubtitle: true,
        subtitleText:
          this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['contacto_deudor'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'email',
        label: this.comunText['correo-judicial'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'telefono',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        placeholder: this.comunText['telefono-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
      {
        name: 'numeroEmpleadasMujeres',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['empleadas_mujeres'],
        type: 'number',
        required: true,
        placeholder: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['empleadas_mujeres'],
        width: '6',
        visible: true,
        maxLength:'5',
        validation: [
          Validators.pattern(Constants.REGEX_TELEFONO)
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
          maxlength: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_numero'],
          pattern: this.comunText['negativo']
        },
      },
      {
        name: 'numeroEmpleadosHombres',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['empleados_hombres'],
        type: 'number',
        required: true,
        placeholder: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['empleados_hombres'],
        width: '6',
        visible: true,
        maxLength:'5',
        validation: [
          Validators.pattern(Constants.REGEX_TELEFONO)
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
          maxlength: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_numero'],
          pattern: this.comunText['negativo']
        },
      },
      // ARCHIVO
      // Certificado de Existencia y Representación Legal
      {
        name: 'representanteLegal',
        label: this.vjiText['validacion-judicial-insolvencia']['representante_legal'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        visible: true,
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      // ARCHIVO
      // Documento mediante el cuál el máximo órgano competente autoriza al representante legal,
    ];
    // SECCION Información de profesionales asociados al deudor
    this.vjiSucursalInformacionProfesionales = [
      {
        name: 'contador',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['contador'],
        type: 'select',
        required: true,
        options: [{
          Id: 1, Nombre: 'Test'
        }],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'revisorFiscal',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['revisor_fiscal'],
        type: 'select',
        required: false,
        options: [{
          Id: 1, Nombre: 'Test'
        }],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'apoderado',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['apoderado'],
        type: 'select',
        required: false,
        options: [{
          Id: 1, Nombre: 'Test'
        }],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      // ARCHIVO
      /**
       * Poder al abogado para realizar la solicitud -> DEPENDE DE SI SELECCIONA APODERADO */
      // SECCION Memoria explicativa de las causas de insolvencia
      /* ARCHIVO
       * Memoria explicativa de las causas de insolvencia
       */
    ];
    // SECCION Supuestos de admisibilidad
    this.vjiSucursalSupuestosAdmisibilidad = [
      {
        name: 'certificoActividad',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['certificado_desarrollo_actividad'] + ":",
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
        },
      },
      // ARCHIVOS
      /**
       * Certificación que acredite la cesación de pagos -> Depende de certificadoDesarrolloActividad opcion 1
       * Anexo de la certificación de cesación de pagos -> Depende de certificadoDesarrolloActividad opcion 1
       * Certificación que acredite la incapacidad de pago -> Depende de certificadoDesarrolloActividad opcion 2
       */
    ];
    // SECCION Relación de Pasivos (Artículo 32, Ley 1429 de 2010)
    this.vjiSucursalRelacionPasivos = [
      {
        name: 'tienePasivosRetenciones',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['tiene_pasivos_retenciones'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
        },
      },
      // Archivos
      /**
       * Certificación de tener o no pasivos por retenciones obligatorias con el fisco
       * Plan para la atención de pasivos por retenciones obligatorias con el fisco -> Depende de que seleccione si
       */
      {
        name: 'tienePasivosDescuentos',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['tiene_pasivos_descuentos'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      // ARCHIVOS
      /**
       * Certificación de tener o no tener pasivos por descuentos efectuados a trabajadores
       * Plan para la atención de pasivos por descuentos efectuados a trabajadores
       */
      {
        name: 'tienePasivosAportes',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['tiene_pasivos_aportes'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      // ARCHIVOS
      /**
       * Certificación de tener o no tener pasivos por aportes al sistema de seguridad social
       * Plan para la atención de pasivos al sistema de seguridad social
       */
    ];
    // SECCION Información financiera con corte al último día calendario del mes anterior
    this.vjiSucursalInformacionFinancieraMes = [
      {
        name: 'fechaEstadoFinancieroMesAnterior',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['fecha_estado_financiero_mes_anterior'],
        type: 'date',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
        isMaxDate: true,
      },
      {
        name: 'valorTotalActivosMesAnterior',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['activos_mes_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.required,
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
      },
      {
        name: 'valorTotalPasivosMesAnterior',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['pasivos_mes_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
      },
      {
        name: 'valorTotalPatrimonioMesAnterior',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['patrimonio_mes_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
      },
      {
        name: 'codigoGrupoPreparadores',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['grupo_preparadores_informacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
        },
      },
    ];
    // ARCHIVOS
    /**
     * Estados financieros del mes anterior (ESF, ER, EFE, ORI, ECP)
     * Notas y certificación a los estados financieros del mes anterior
     */
    // SECCION Información financiera con corte al último año anterior
    this.vjiSucursalInformacionFinancieraAnio = [
      {
        name: 'fechaEstadoFinancieroAnioAnterior',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['fecha_estado_financiero_anio_anterior'],
        type: 'date',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
        isMaxDate: true
      },
      {
        name: 'valorTotalActivosAnioAnterior',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['activos_anio_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
      },
      {
        name: 'valorTotalPasivosAnioAnterior',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['pasivos_anio_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
      },
      {
        name: 'valorTotalIngresosOrdinariosAnioAnterior',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['ingresos_anio_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
      },
      {
        name: 'valorTotalOtrosIngresosAnioAnterior',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['otros_ingresos_anio_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
      },
      {
        name: 'tieneIversionesSubsidiarias',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['tiene_iversiones_subsidiarias'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'valorTotalGananciaMetodoParticipacion',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['valor_ganancias_participacion'],
        type: 'decimal',
        required: false,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
        dependsOn: 'tieneIversionesSubsidiarias',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'valorTotalGananciaMetodoAlCosto',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['valor_ganancias_costo'],
        type: 'decimal',
        required: false,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
        dependsOn: 'tieneIversionesSubsidiarias',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'valorTotalGananciaMetodoValorRazonable',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['valor_ganancias_razonable'],
        type: 'decimal',
        required: false,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          pattern: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal'],
          maxlength: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario']
        },
        dependsOn: 'tieneIversionesSubsidiarias',
        visibilityCondition: value => value == 1,
      },
    ];
    // Sección Conjunto completo de estados financieros comparativos
    this.vjiSucursalEstadosFinancieros = [
      {
        name: 'informacionRemitida',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['informacion_remitida'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      //ARCHIVOS
      /**
       * SELECCIONA NO
       * Estados financieros del último año (2023)
       * Notas y certificación a los estados financieros del último año (2023)
       * Dictamen del revisor fiscal del último año (2023)(si aplica)
       * Estados financieros del penúltimo año (2022)
       * Notas y certificación a los estados financieros del penúltimo año (2022)
       * Dictamen del revisor fiscal del penúltimo año (2022) (si aplica)
       * Estados financieros del antepenúltimo año (2021)
       * Notas a estados financieros del antepenúltimo año (2021)
       * Dictamen del revisor fiscal del antepenúltimo año (2021) (si aplica)
       */
      // Selecciona SI
      {
        name: 'radicado2023',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['radicado_2023'] + this.lastYear.toString(),
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES)
        ],
        visible: false,
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['letras_numeros'],
          pattern: this.comunText['razon-social-pattern'],
        },
        dependsOn: 'informacionRemitida',
        visibilityCondition: value => value == 1,
      }
    ];

    // SECCION Inventario de activos y pasivos con corte al último día del mes anterior
    // ARCHIVOS
    /**
     * Inventario de activos del mes anterior
     * Inventario de pasivos del mes anterior
     */
    // SECCION Otros documentos requeridos
    this.vjiSucursalOtrosDocumentos = [
      {
        name: 'pasivosPensionales',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['pasivos_pensionales'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      // ARCHIVOS
      // SELECCIONA SI
      /**
       * Certificación del monto de las obligaciones causadas por cálculo actuarial
       * Documento que acredita el cálculo actuarial
       * Aprobación del cálculo actuarial
       * Certificación de encontrarse al día en mesadas pensionales, bonos y títulos pensionales
       */
      {
        name: 'garanteTerceros',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['garante_terceros'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      // Archivos
      /**
       * Certificación en la que se relacione los terceros a los cuales el deudor es (avalista, garante o codeudor de terceros)
       *
       */
    ];
    /**SECCION Plan de negocios, Flujo de caja proyectado Y Proyectos de calificación y graduación de créditos y derechos de voto
     *
     * Certificación depende si seleccionan si, el resto no dependen de ninguno
     * Plan de negocios de reorganización
     * Flujo de caja proyectado
     * Proyecto de calificación y graduación de créditos y proyecto de determinación de derechos de voto
     */
    /**
     * SECCION Reporte de bienes sujetos a garantías mobiliarias
     */
    this.vjiSucursalReporteBienesMobiliarios = [
      {
        name: 'garantiaInmobiliaria',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['garante_inmobiliaria'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.vjiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
    ];
    // Archivos
    // SELECCIONA SI
    /**
     * Certificación de bienes sujetos a garantías mobiliarias, adicionalmente, indicar cuáles de los mismos son necesarios para la actividad del deudor
     * Avalúo de los bienes
     * Certificación que relacione las obligaciones que surgen de la adquisición del bien sujeto a garantía
    */
    /**
     * SECCION Documentos Adicionales
     * Archivo
    */
    this.vjiSucursalDocumentosAdicionales = [
      // ARCHIVO
      {
        name: 'descripcion',
        label: this.vjiText['reorganizacion-ordinaria-insolvencia']['comun']['descripcion'],
        type: 'text',
        required: false,
        width: '6',
        noConvertToUpperCase: true,
        validation: [
          Validators.pattern(Constants.REGEX_ACTA_PROTESTA),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
        },
      },
    ];
  }
  // <!-- Sección inicial -->
  onSubmitSucursalIdentificacionDeudor(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formIdentificacionDeudor = event.form;
    let formGroup = event.form;
    let idTipoDocumento: number = +formGroup.get('tipoDeDocumento')?.value;
    let identificacion: string = formGroup.get('numberOfDocument')?.value;
    const numeroDocumento = this.vjiSucursalIdentificacionDeudor.find(
      field => field.name == 'numberOfDocument'
    );
    if (
      event.controlName == 'tipoDeDocumento' ||
      event.controlName == 'numberOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (
          idTipoDocumento == 1 ||
          idTipoDocumento == 2
        ) {
          if (numeroDocumento != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumento.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumento.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumento.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumento != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(8),
                Validators.pattern(
                  Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                ),
              ]);
            numeroDocumento.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumento.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        } else {
          if (numeroDocumento != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(9),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumento.errorMessages!['maxlength'] =
              this.comunText['nit-maxlength'];
            numeroDocumento.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumento.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        }
        formGroup.get('numberOfDocument')?.updateValueAndValidity();
      }
    }
    if (event.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      const idPaisSeleccionado = +formGroup.get('country')?.value;
      if (idPais === idPaisSeleccionado) {
        formGroup?.controls['departament']?.addValidators(Validators.required);
        formGroup?.controls['municipality']?.addValidators(Validators.required);
        formGroup?.controls['otroDepartamento']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipio']?.removeValidators(
          Validators.required
        );
        formGroup.get('otroMunicipio')?.updateValueAndValidity();
        formGroup.get('otroDepartamento')?.updateValueAndValidity();
      } else {
        let clearInputs: boolean = false
        if (formGroup?.controls['country'].value) {
          this.auxIdCountry.push(formGroup?.controls['country'].value)
          if (this.auxIdCountry.length > 1) {
            clearInputs = formGroup?.controls['country'].value != this.auxIdCountry[this.auxIdCountry.length - 2]
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamento'].setValue('')
          formGroup?.controls['otroMunicipio'].setValue('')
        }
        formGroup?.controls['departament']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['municipality']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamento']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipio']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipio']?.markAsDirty();
        formGroup?.controls['otroMunicipio']?.markAllAsTouched();
        formGroup.get('otroMunicipio')?.updateValueAndValidity();
        formGroup.get('otroDepartamento')?.updateValueAndValidity();
        this.vjiSucursalIdentificacionDeudor.forEach((field: FormField) => {
          if (['otroMunicipio', 'otroDepartamento']
            .includes(field.name)
          ) {
            field.required = true
          }
        });
      }
    }
    this.mostrarCamposRequeridos(formGroup)
  }

  // <!-- Sección Información de profesionales asociados al deudor -->
  onSubmitSucursalInformacionProfesionales(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formInformacionProfesionales = event.form;
  }

  // <!-- Sección Supuestos de admisibilidad-->
  onSubmitSucursalSupuestosAdmisibilidad(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formSupuestosAdmisibilidad = event.form;

  }

  // <!-- Sección Relación de Pasivos (Artículo 32, Ley 1429 de 2010)-->
  onSubmitSucursalRelacionPasivos(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formRelacionPasivos = event.form;
  }

  // <!-- Sección Información financiera con corte al último día calendario del mes anterior-->
  onSubmitSucursalInformacionFinancieraMes(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formInformacionFinancieraMes = event.form;
  }

  // <!-- Sección Información financiera con corte al último año anterior-->
  onSubmitSucursalInformacionFinancieraAnio(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = event.form;
    this.formInformacionFinancieraAnio = event.form;
    if (event.controlName == 'tieneIversionesSubsidiarias') {
      const valor = this.formInformacionFinancieraAnio.get('tieneIversionesSubsidiarias')?.value;
      const valorTotalGananciaMetodoParticipacion = this.vjiSucursalInformacionFinancieraAnio.find(
        field => field.name == 'valorTotalGananciaMetodoParticipacion'
      );
      const valorTotalGananciaMetodoAlCosto = this.vjiSucursalInformacionFinancieraAnio.find(
        field => field.name == 'valorTotalGananciaMetodoAlCosto'
      );
      const valorTotalGananciaMetodoValorRazonable = this.vjiSucursalInformacionFinancieraAnio.find(
        field => field.name == 'valorTotalGananciaMetodoValorRazonable'
      );
      if (valor == 1) {
        this.setearObligatorio('valorTotalGananciaMetodoParticipacion',
          this.vjiSucursalInformacionFinancieraAnio,
          true)
        this.setearObligatorio('valorTotalGananciaMetodoAlCosto',
          this.vjiSucursalInformacionFinancieraAnio,
          true)
        this.setearObligatorio('valorTotalGananciaMetodoValorRazonable',
          this.vjiSucursalInformacionFinancieraAnio,
          true)
        if (valorTotalGananciaMetodoParticipacion != undefined ||
          valorTotalGananciaMetodoAlCosto != undefined ||
          valorTotalGananciaMetodoValorRazonable != undefined
        ) {
          formGroup
            .get('valorTotalGananciaMetodoParticipacion')
            ?.addValidators([
              Validators.required,
              Validators.pattern(/^\d+$/),
            ]);
          formGroup
            .get('valorTotalGananciaMetodoAlCosto')
            ?.addValidators([
              Validators.required,
              Validators.pattern(/^\d+$/),
            ]);
          formGroup
            .get('valorTotalGananciaMetodoValorRazonable')
            ?.addValidators([
              Validators.required,
              Validators.pattern(/^\d+$/),
            ]);
        }
        formGroup.get('valorTotalGananciaMetodoParticipacion')?.updateValueAndValidity();
        formGroup.get('valorTotalGananciaMetodoAlCosto')?.updateValueAndValidity();
        formGroup.get('valorTotalGananciaMetodoValorRazonable')?.updateValueAndValidity();

      } else {
        this.setearObligatorio('valorTotalGananciaMetodoParticipacion',
          this.vjiSucursalInformacionFinancieraAnio,
          false)
        this.setearObligatorio('valorTotalGananciaMetodoAlCosto',
          this.vjiSucursalInformacionFinancieraAnio,
          false)
        this.setearObligatorio('valorTotalGananciaMetodoValorRazonable',
          this.vjiSucursalInformacionFinancieraAnio,
          false)
        formGroup
          .get('valorTotalGananciaMetodoParticipacion')
          ?.clearValidators();
        formGroup
          .get('valorTotalGananciaMetodoAlCosto')
          ?.clearValidators();
        formGroup
          .get('valorTotalGananciaMetodoValorRazonable')
          ?.clearValidators();
        formGroup.get('valorTotalGananciaMetodoParticipacion')?.updateValueAndValidity();
        formGroup.get('valorTotalGananciaMetodoAlCosto')?.updateValueAndValidity();
        formGroup.get('valorTotalGananciaMetodoValorRazonable')?.updateValueAndValidity();

      }
    }
  }

  // <!-- Sección Conjunto completo de estados financieros comparativos-->
  onSubmitSucursalEstadosFinancieros(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formEstadosFinancieros = event.form;
    let formGroup = event.form;
    if (event.controlName == 'informacionRemitida') {
      const valor = this.formEstadosFinancieros.get('informacionRemitida')?.value;
      const radicado2023 = this.vjiSucursalEstadosFinancieros.find(
        field => field.name == 'radicado2023'
      );
      if (valor == 1) {
        this.setearObligatorio('radicado2023',
          this.vjiSucursalEstadosFinancieros,
          true)
        if (radicado2023 != undefined) {
          formGroup
            .get('radicado2023')
            ?.addValidators([
              Validators.required,
              Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES),
            ]);
        }
        formGroup.get('radicado2023')?.updateValueAndValidity();

      } else {
        this.setearObligatorio('radicado2023',
          this.vjiSucursalEstadosFinancieros,
          false)
        formGroup
          .get('radicado2023')
          ?.clearValidators();
        formGroup.get('radicado2023')?.updateValueAndValidity();

      }
    }
  }

  // <!-- Sección Otros documentos requeridos-->
  onSubmitSucursalOtrosDocumentos(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formOtrosDocumentos = event.form;

  }

  // <!-- Sección Reporte de bienes sujetos a garantías mobiliarias-->
  onSubmitSucursalReporteBienesMobiliarios(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formReporteBienesMobiliarios = event.form;

  }

  // <!-- Sección Reporte de bienes sujetos a garantías mobiliarias-->
  onSubmitSucursalDocumentosAdicionales(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formDocumentosAdicionales = event.form;
  }

  // Documentos
  subirArchivo(subio: any) {
    this.enviarDocumentos = false;
    if (subio) {
    }
  }

  validarArchivosCargados(archivos: ArchivoItemDto[]) {
    this.archivosCargados = archivos;
  }

  setearObligatorio(name: string, form: FormField[], required: boolean) {
    form.forEach(field => {
      if (name == field.name) {
        field.required = required;
      }
    });
  }

  mostrarCamposRequeridos(formGroup: FormGroup) {
    const camposRequeridos = Object.keys(formGroup.controls).filter(
      controlName =>
        formGroup.get(controlName)?.hasValidator(Validators.required)
    );
    // console.log(camposRequeridos);
  }

  // Validar formularios validos
  getValidForms(): boolean {
    return this.formIdentificacionDeudor.invalid &&
      this.formInformacionProfesionales.invalid
      && this.formSupuestosAdmisibilidad.invalid
      && this.formRelacionPasivos.invalid
      && this.formInformacionFinancieraMes.invalid
      && this.formInformacionFinancieraAnio.invalid
      && this.formEstadosFinancieros.invalid
      && this.formOtrosDocumentos.invalid
      && this.formReporteBienesMobiliarios.invalid;
  }

  // construccion body para servicio
  buildFormTramite(enviar: boolean): TramiteValidacionJudicialDto {
    const tramite: TramiteValidacionJudicialDto = {
      idCreador: this.dataUsuario.idUsuario!,
      id: this.idTramite ?? undefined,
      tipoSolicitante: { id: this.getIdSolicitante(this.idTipoSolicitante!) },
      idTipoTramite: this.tipoTramite,
      normaAplicable: this.formIdentificacionDeudor.get('normaAplicable')?.value,
      tipoIdentificacion: { id: this.formIdentificacionDeudor.get('tipoDeDocumento')?.value },
      numeroIdentificacion: this.formIdentificacionDeudor.get('numberOfDocument')?.value,
      nombreRazonSocial: this.formIdentificacionDeudor.get('nombre')?.value,
      codigoCIIU: { id: this.formIdentificacionDeudor.get('codigoCIIU')?.value },
      macrosector: { id: this.formIdentificacionDeudor.get('macrosector')?.value },
      paisDomicilio: { id: this.formIdentificacionDeudor.get('country')?.value },
      departamentoDomicilio: { id: this.formIdentificacionDeudor.get('departament')?.value },
      municipioDomicilio: { id: this.formIdentificacionDeudor.get('municipality')?.value },
      direccionNotificacion: this.formIdentificacionDeudor.get('addressNotificacion')?.value,
      correoElectronicoNotificacion: this.formIdentificacionDeudor.get('email')?.value,
      telefono: this.formIdentificacionDeudor.get('telefono')?.value,
      numeroEmpleadosMujeres: this.formIdentificacionDeudor.get('numeroEmpleadasMujeres')?.value,
      numeroEmpleadosHombres: this.formIdentificacionDeudor.get('numeroEmpleadosHombres')?.value,
      representanteLegal: { id: this.formIdentificacionDeudor.get('representanteLegal')?.value },
      contador: { id: this.formInformacionProfesionales.get('contador')?.value },
      revisorFiscal: { id: this.formInformacionProfesionales.get('revisorFiscal')?.value },
      idApoderado: this.formInformacionProfesionales.get('apoderado')?.value,
      certificoActividad: { id: this.formSupuestosAdmisibilidad.get('certificoActividad')?.value },
      tienePasivosRetenciones: this.getBooleanValue('tienePasivosRetenciones', this.formRelacionPasivos),
      tienePasivosDescuentos: this.getBooleanValue('tienePasivosDescuentos', this.formRelacionPasivos),
      tienePasivosAportes: this.getBooleanValue('tienePasivosAportes', this.formRelacionPasivos),
      fechaEstadoFinancieroMesAnterior: this.formInformacionFinancieraMes.get('fechaEstadoFinancieroMesAnterior')?.value,
      valorTotalActivosMesAnterior: this.formInformacionFinancieraMes.get('valorTotalActivosMesAnterior')?.value,
      valorTotalPasivosMesAnterior: this.formInformacionFinancieraMes.get('valorTotalPasivosMesAnterior')?.value,
      valorTotalPatrimonioMesAnterior: this.formInformacionFinancieraMes.get('valorTotalPatrimonioMesAnterior')?.value,
      codigoGrupoPreparadores: this.getNombreGrupoPreparadores(this.formInformacionFinancieraMes.get('codigoGrupoPreparadores')?.value),
      fechaEstadoFinancieroAnioAnterior: this.formInformacionFinancieraAnio.get('fechaEstadoFinancieroAnioAnterior')?.value,
      valorTotalActivosAnioAnterior: this.formInformacionFinancieraAnio.get('valorTotalActivosAnioAnterior')?.value,
      valorTotalPasivosAnioAnterior: this.formInformacionFinancieraAnio.get('valorTotalPasivosAnioAnterior')?.value,
      valorTotalIngresosOrdinariosAnioAnterior: this.formInformacionFinancieraAnio.get('valorTotalIngresosOrdinariosAnioAnterior')?.value,
      valorTotalOtrosIngresosAnioAnterior: this.formInformacionFinancieraAnio.get('valorTotalOtrosIngresosAnioAnterior')?.value,
      tieneInversiones: this.getBooleanValue('tieneIversionesSubsidiarias', this.formInformacionFinancieraAnio),
      valorTotalGananciaMetodoParticipacion: this.formInformacionFinancieraAnio.get('valorTotalGananciaMetodoParticipacion')?.value,
      valorTotalGananciaMetodoAlCosto: this.formInformacionFinancieraAnio.get('valorTotalGananciaMetodoAlCosto')?.value,
      valorTotalGananciaMetodoValorRazonable: this.formInformacionFinancieraAnio.get('valorTotalGananciaMetodoValorRazonable')?.value,
      tieneInformacionRemitida: this.getBooleanValue('informacionRemitida', this.formEstadosFinancieros),
      radicado2023: this.formEstadosFinancieros.get('radicado2023')?.value,
      tieneCausalDisolucion: this.getBooleanValue('causalDisolucion', this.formOtrosDocumentos),
      tienePasivosPensionales: this.getBooleanValue('pasivosPensionales', this.formOtrosDocumentos),
      esGaranteTerceros: this.getBooleanValue('garanteTerceros', this.formOtrosDocumentos),
      tieneBienesGarantiaInmobiliaria: this.getBooleanValue('garantiaInmobiliaria', this.formReporteBienesMobiliarios),
      descripcion: this.formDocumentosAdicionales.get('descripcion')?.value,
      enviar: enviar
    };
    const tramiteLimpio = this.limpiarObjeto(tramite);
    if (tramiteLimpio.paisDomicilio.id != 1) {
      tramiteLimpio.departamentoExtranjero = this.formIdentificacionDeudor.get('otroDepartamento')?.value;
      tramiteLimpio.ciudadExtranjero = this.formIdentificacionDeudor.get('otroMunicipio')?.value;
    }
    return tramiteLimpio;
  }

  getIdSolicitante(codigo: string): number {
    let codigoLista: number = 0;
    this.listaSolicitante.forEach(elemento=>{
      if (elemento.Codigo == codigo) {
        codigoLista = +elemento.Id!;
      }
    })
    return codigoLista;
  }

  limpiarObjeto<T extends Record<string, any>>(obj: T): T {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, value]) => !(typeof value === 'boolean' && value === undefined))
    ) as T;
  }

  getBooleanValue(controlName: string, form: FormGroup): boolean | undefined {
    const value = form.get(controlName)?.value;
    return value === undefined ? undefined : value === 1;
  }

  getNombreGrupoPreparadores(idGrupo: number): string {
    let nombre: string = '';
    this.grupoPreparadores.forEach(elemento => {
      if (idGrupo == elemento.Id) {
        nombre = elemento.Nombre;
      }
    })
    return nombre;
  }

  getIdGrupoPreparadores(nombreGrupo: string): number|undefined {
    let id: number = 0;
    this.grupoPreparadores.forEach(elemento => {
      if (nombreGrupo == elemento.Nombre) {
        id = elemento.Id;
      }
    })
    return nombreGrupo.length > 0 ? id : undefined;
  }

  // Envio formulario
  async onSubmitFormulario(enviar: boolean) {
    this.enviarEntidad = enviar;

    let tramite = this.buildFormTramite(enviar);
    this.serviceValidacionJ.crearTramiteSSVjiSociedad(tramite).subscribe(
      async response => {
        if (response.success) {
          this.idTramite = response.data?.Id!;
          this.idTramiteSsoVji = response.data?.Id!;
          if (enviar) {
            this.enviarDocumentos = true;
            this.alertaModalService
              .exito(
                this.alertaText['proceso-enviado'],
                this.alertaText['asuntos-alertas']['tramite-enviado'].replace('{{entidad}}', this.entidad),
              )
              .then(() => {
                this.router.navigate(['/expediente']);
              });
          } else {
            this.enviarDocumentos = true;
            this.alertaModalService.exito(
              this.alertaText['asuntos-alertas']['tramite-guardado']
            );
          }
        }
      },
      err => {
        console.error(err);
      }
    );
  }

  // Get data usuario logeado

  getData() {
    this.dataUsuario = this.textTransformService.transformarAMayusculas(this.dataUsuario)
    setTimeout(() => {
      this.vjiSucursalIdentificacionDeudor = this.vjiSucursalIdentificacionDeudor.map(field => {
        switch (field.name) {
          case 'tipoDeDocumento':
            field.value = this.getIdDocumento(String(this.dataUsuario.tipoDocumento));
            break;
          case 'numberOfDocument':
            field.value = this.dataUsuario.identificacion;
            break;
          case 'nombre':
            field.value = this.dataUsuario.primerNombre;
            break;
          case 'country':
            field.value = this.dataUsuario.pais;
            break;
          case 'departament':
            field.value = this.dataUsuario.departamento;
            break;
          case 'municipality':
            field.value = this.dataUsuario.municipio;
            break;
          case 'otroDepartamento':
            field.value = this.dataUsuario.otroDepartamento ?? '';
            break;
          case 'otroMunicipio':
            field.value = this.dataUsuario.otroMunicipio ?? '';
            break;
          case 'addressNotificacion':
            field.value = this.dataUsuario?.direccion?.find(
              (elemento: {
                Direccion_Notificacion?: string;
                Es_Primaria?: boolean;
                Id?: number
              }) => elemento.Es_Primaria
            )?.Direccion_Notificacion ??
              this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ?? '';
            break;
          case 'email':
            field.value = this.dataUsuario.correoElectronico;
            break;
          case 'telefono':
            field.value = this.dataUsuario.telefonoPrincipal;
            break;


        }
        return field;
      });
    }, 800);

  }

  // obtiene el id del tipo de documento por nombre
  getIdDocumento(tipoDocumento: string): number {
    if (typeof tipoDocumento == 'string') {
      const documento = this.listaTiposDocumento.find(
        (elemento: any) => elemento.TipoDocumento === tipoDocumento
      );
      return +documento?.Id!;
    } else {
      return tipoDocumento[0];
    }
  }

  anterior(paso: number) {
  }

}
